<template>
    <div class="dropdown w-100">
        <button class="btn btn-secondary btn-block text-left bg-white text-dark dropdown-toggle" type="button"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span v-if="selectedOrderTypes.length === 0" class="text-muted">
                {{ __('actions.select_thing', {thing: __('general.order_type')}) }}
            </span>
            <span v-else class="d-inline-block">
                <span class="d-flex flex-row gap-1">
                    <OrderTypeBadge v-for="orderType in selectedOrderTypes"
                                    :key="orderType"
                                    :type="orderType"
                                    class="font-size-xs"
                                    hide-icon
                                    light
                    >
                        {{ __('orders.types.' + orderType) }}
                    </OrderTypeBadge>
                </span>
            </span>
        </button>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <li v-for="(color, orderType) in $page.props.order_types" class="px-4 py-2" @click.stop>
                <Checkbox :bg-color="color" v-model="selectedTypes[orderType]" class="bg-hover-light-light">
                    <div class="text-uppercase">
                        {{ __('orders.types.' + orderType) }}
                    </div>
                </Checkbox>
            </li>
        </ul>
    </div>
</template>

<script>
import Checkbox from "@components/Form/Checkbox.vue";
import OrderTypeIcon from "@components/Orders/OrderTypeIcon.vue";
import Badge from "@components/Badge.vue";
import OrderTypeBadge from "@components/Orders/OrderTypeBadge.vue";

export default {
    components: {OrderTypeBadge, Badge, OrderTypeIcon, Checkbox},

    props: {
        value: {
            type: Object,
            default() {
                return {
                    'pickup': true,
                    'delivery': true,
                    'reservation': true,
                };
            }
        }
    },

    data() {
        return {
            selectedTypes: this.value
        }
    },

    computed: {
        selectedOrderTypes() {
            let out = [];
            for (let type in this.selectedTypes) {
                if (this.selectedTypes[type]) {
                    out.push(type);
                }
            }
            return out;
        }
    },

    watch: {
        selectedTypes: {
            deep: true,
            handler(newValue, oldValue) {
                this.$emit('input', newValue)
            }
        }
    }
}
</script>
